"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignedTo = void 0;
const common_1 = require("../../common");
const employee_model_1 = require("./employee.model");
const seat_model_1 = require("./seat.model");
class AssignedTo extends common_1.MongoSubDocument {
}
exports.AssignedTo = AssignedTo;
//# sourceMappingURL=assigned-to.model.js.map